export default "__VITE_PUBLIC_ASSET__b76f85ba__"